import { BaseModel } from '@/api/base-model'
import { ShareAPI } from '@/api/backend-client'
import { OrderType, ReferralType } from '@/api/types'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'

export enum ShareType {
    INTERNAL = 'internal',
    EXTERNAL = 'external',
}

export class Share extends BaseModel<Share> {
    protected collectionName = ShareAPI.collectionName

    constructor(
        public company: Company,
        public id: string,
        public type: ShareType,
        public orderType: OrderType,
        public referralType: ReferralType,
        public referralPipeline: Pipeline,
        public percentage: string,
    ) { super(id) }

    static fromData(data: any): Share {
        if (data === null || typeof data === 'string' || data instanceof Share) {
            return data
        }

        return new Share(
            Company.fromData(data.company),
            data.id,
            data.type,
            data.orderType,
            data.referralType,
            Pipeline.fromData(data.referralPipeline),
            data.percentage,
        )
    }
}
